module.exports = __webpack_public_path__ + "static/media/31JFA5.fa0552c2.jpg";